module.exports = __webpack_public_path__ + "img/karakters-20.b44be8f8.jpg";